module.exports = __webpack_public_path__ + "static/media/ssangyong.fb4cbb71.png";